import { useMutation } from "@tanstack/react-query";
import type {
  ResetPasswordErrorReason,
  ResetPasswordRequest
} from "@dealer-center/ddc-pages-configuration-interface";
import {
  type ConfigurationWriteRequestError,
  configurationWriteRequest
} from "./configurationRequest";

export interface ResetPasswordVariables {
  userId: string;
  accountId: string;
  password: string;
}

/**
 * Password hygiene: no `mutationKey` (tooling reads it), `gcTime: 0` so the settled `variables`
 * are dropped, and nothing is logged or stored.
 */
export const useResetPasswordMutation = () =>
  useMutation<
    void,
    ConfigurationWriteRequestError<ResetPasswordErrorReason>,
    ResetPasswordVariables
  >({
    mutationFn: ({ userId, accountId, password }) => {
      const body: ResetPasswordRequest = { password };

      return configurationWriteRequest<ResetPasswordErrorReason>(
        { resource: "resetpassword", userId, accountId },
        body
      );
    },
    gcTime: 0
  });
